// extracted by mini-css-extract-plugin
export var bodyRow = "_dm-d";
export var cardColumns = "_dm-e";
export var ellipsesOverflow = "_dm-2";
export var flatBottomCorners = "_dm-3";
export var flatTopCorners = "_dm-4";
export var headerActionsDropdown = "_dm-f";
export var headerBottomRow = "_dm-c";
export var headerTopRow = "_dm-b";
export var orderDetailsWrapper = "_dm-0";
export var orderInfoContainer = "_dm-1";
export var productDetails = "_dm-9";
export var productImage = "_dm-5";
export var responsiveTable = "_dm-8";
export var shipmentContainer = "_dm-a";
export var tableBottomLeft = "_dm-6";
export var tableBottomRight = "_dm-7";
export var trackingLink = "_dm-g";